import React, { useEffect } from "react";
import { useParams, useHistory } from "react-router";
import useMoodboardData from "../../hooks/moodboardData/useMoodboardData";

import RelativeContainer from "../containers/RelativeContainer";
import Moodboard from "../Moodboard/Moodboard";

const MoodboardPage = ({ height, width, user }) => {
  const { admin, user: currentUser, loggingIn } = user;
  let { routeId: moodboardPath } = useParams();
  const history = useHistory();

  const moodboard = useMoodboardData({
    moodboardPath,
    admin,
    user: currentUser,
  });

  // Handle errors
  useEffect(() => {
    if (moodboard.error === "invalid path") {
      history.push("/404");
    } else if (moodboard.error === "private or invalid") {
      // For unauthenticated users trying to access private moodboard
      history.push("/login");
    }
  }, [moodboard.error, history]);

  // Only show nothing while initially checking auth state
  if (loggingIn) {
    return null;
  }

  return (
    <RelativeContainer
      style={{
        height,
        width,
      }}
    >
      <Moodboard moodboard={moodboard} height={height} width={width} />
    </RelativeContainer>
  );
};

export default MoodboardPage;
